var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-page-shell"},[(_vm.title)?_c('div',{staticClass:"list-page-shell__heading"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._v(" "),(_vm.hint)?_c('p',{staticClass:"list-page-shell__hint"},[_vm._v(_vm._s(_vm.hint))]):_vm._e(),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-186cae33","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/ListPageShell.vue
// module id = 5hf2
// module chunks = 0